module.exports = __webpack_public_path__ + "img/courseDet.8d683400.png";